import { injectGlobal } from 'styled-components'
import { getVars } from './utils'

import openSansRegularWoff from '../fonts/opensans-regular.woff'
import openSansRegularWoff2 from '../fonts/opensans-regular.woff2'
import openSansLightWoff from '../fonts/opensans-light.woff'
import openSansLightWoff2 from '../fonts/opensans-light.woff2'
import openSansSemiBoldWoff from '../fonts/opensans-semibold.woff2'
import openSansSemiBoldWoff2 from '../fonts/opensans-semibold.woff2'
import openSansBoldWoff from '../fonts/opensans-bold.woff'
import openSansBoldWoff2 from '../fonts/opensans-bold.woff2'
import openSansExtraBoldWoff from '../fonts/opensans-extrabold.woff'
import openSansExtraBoldWoff2 from '../fonts/opensans-extrabold.woff2'

injectGlobal`
  *, *:before, *:after{
    box-sizing: border-box;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url(${openSansLightWoff2}) format('woff2'),
         url(${openSansLightWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url(${openSansRegularWoff2}) format('woff2'),
         url(${openSansRegularWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url(${openSansSemiBoldWoff2}) format('woff2'),
         url(${openSansSemiBoldWoff}) format('woff');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url(${openSansBoldWoff2}) format('woff2'),
         url(${openSansBoldWoff}) format('woff');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'Open Sans';
    src: url(${openSansExtraBoldWoff2}) format('woff2'),
         url(${openSansExtraBoldWoff}) format('woff');
    font-weight: 800;
    font-style: normal;
  }

  body{
    font-family: ${getVars('fontFamily', 'main')};
    color: ${getVars('textColor', 'base')};
    font-size: ${getVars('fontSize', 'body')};
    line-height: ${getVars('lineHeight', 'body')};
  }

  h1,h2,h3,h4,h5,h6{
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: 0;
  }

  p{
    margin-top: 0;
    margin-bottom: 1.5em;
  }

  a,
  a:visited{
    color: ${getVars('textColor', 'linkColor')};
    &:hover{
      color: ${getVars('textColor', 'linkColorHover')};
    }
    &:active{
      color: ${getVars('textColor', 'linkColorActive')};
    }
  }

  img{
    max-width: 100%;
  }

  .themeDark{
    color: ${getVars('textColor', 'baseLight')};
    background: ${getVars('bg', 'dark1')};
  }


`



// WEBPACK FOOTER //
// ./src/global/globalStyles.js